export const PULL_FACTORS = ['Humor/Entertainment', 'World/Premise', 'Characters', 'Tone/Voice', 'Story Potential'];
